// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var header = "Header-module--header--3VlH4";
export var topNavBar = "Header-module--topNavBar--3kXuK";
export var leftSideLinks = "Header-module--leftSideLinks--3O6oj";
export var rightSideLinks = "Header-module--rightSideLinks--1UylV";
export var externalLink = "Header-module--externalLink--27chl";
export var hidden = "Header-module--hidden--OLCwo";
export var navBar = "Header-module--navBar--3eshU";
export var container = "Header-module--container--fWTq6";
export var logoContainer = "Header-module--logoContainer--2QQsc";
export var logo = "Header-module--logo--OCmta";
export var menuCountryAndNerthus = "Header-module--menuCountryAndNerthus--3t2xM";
export var countryAndNerthus = "Header-module--countryAndNerthus--lYgx6";
export var icon = "Header-module--icon--CwVde";
export var country = "Header-module--country--GTZTp";
export var nerthusButton = "Header-module--nerthusButton--359XT";
export var hamburgerMenu = "Header-module--hamburgerMenu--1gb4P";
export var shadow = "Header-module--shadow--3uxC-";
export var dropDownMenuWrapperWindow = "Header-module--dropDownMenuWrapperWindow--1bPcq";
export var dropDownMenuWrapper = "Header-module--dropDownMenuWrapper--13k7s";
export var menuOpen = "Header-module--menuOpen--17a_j";
export var menuWrapper = "Header-module--menuWrapper--3U-68";